module.exports = __webpack_public_path__ + "static/media/watermark.7881b04a.png";